import { render, staticRenderFns } from "./InspectionRequest.vue?vue&type=template&id=19fff0de&scoped=true"
import script from "./InspectionRequest.vue?vue&type=script&lang=js"
export * from "./InspectionRequest.vue?vue&type=script&lang=js"
import style0 from "./InspectionRequest.vue?vue&type=style&index=0&id=19fff0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fff0de",
  null
  
)

export default component.exports